import { useContext } from 'react';
import { StoreApi, useStore } from 'zustand';

import { RouterStore } from '../../stores/router/types';

import { StoresContext, WidgetStores } from './storesProvider';

interface WidgetCreatedStores {
  routerStore: RouterStore;
}

export const useWidgetStore = <
  T,
  StoreName extends keyof WidgetStores,
  SelectedStore extends WidgetCreatedStores[StoreName]
>(
  storeName: StoreName,
  stateSelector: (state: SelectedStore) => T
): T => {
  const storeSelector = (stores: WidgetStores) => stores[storeName] as StoreApi<SelectedStore>;

  const context = useContext(StoresContext);

  if (!context) {
    throw new Error('useWidgetStore must be used within an WidgetProvider');
  }

  const store = storeSelector(context);
  return useStore(store, stateSelector);
};
